import React, { useState } from 'react';
import TestimonialCard from './TestimonialCard';

const Testimonials = () => {
    return (
        <section className="py-12 bg-gray-50 sm:py-16 lg:py-20">
            <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8 pt-8">
                <div className="flex flex-col items-center">
                    <div className="text-center">
                        {/* <p className="text-lg font-medium text-gray-600 font-pj">2,157 people have said how good Rareblocks</p> */}
                        <h2 className="mt-4 font-bold text-gray-900 text-4xl xl:text-5xl font-pj">Take a look at some real examples</h2>
                    </div>

                    <div className="relative mt-10 md:mt-16">

                        <div className="relative grid max-w-lg grid-cols-1 gap-6 mx-auto md:max-w-none lg:gap-10 md:grid-cols-3">
                            <div className="">
                                <TestimonialCard
                                    title="London Recommendations"
                                    list_username="23dittrich"
                                    thread_username="xhfloz"
                                    list_link="https://maps.app.goo.gl/tsgLr7AM99AgwaXP6"
                                    thread_link="https://x.com/23dittrich/status/1826970072134332726"
                                    type="pro"
                                />
                            </div>
                            <div className="">
                                <TestimonialCard
                                    title="Restaurants in Madrid"
                                    list_username="pacojonar"
                                    thread_username="carmen_emeuve"
                                    list_link="https://maps.app.goo.gl/39VzsqvRgTFhaUJe8"
                                    thread_link="https://x.com/pacojonar/status/1826762530607562913"
                                    type="free"
                                />
                            </div>
                            <div className="">
                                <TestimonialCard
                                    title="Miami Beach Recommendations"
                                    list_username="23dittrich"
                                    thread_username="TyBarbo"
                                    list_link="https://maps.app.goo.gl/7C5qhPt2wsTgGAYY6"
                                    thread_link="https://x.com/23dittrich/status/1827092403922333816"
                                    type="pro"
                                />
                            </div>
                            <div className="hidden md:flex">
                                <TestimonialCard
                                    title="Copenhagen Recommendations"
                                    list_username="23dittrich"
                                    thread_username="jeff_weinstein"
                                    list_link="https://maps.app.goo.gl/8XP4eJq42kj8HTWTA"
                                    thread_link="https://x.com/23dittrich/status/1825942714179084498"
                                    type="pro"
                                />
                            </div>
                            <div className="hidden md:flex">
                                <TestimonialCard
                                    title="San Diego recs"
                                    list_username="23dittrich"
                                    thread_username="GeekyHooker"
                                    list_link="https://maps.app.goo.gl/XDa4qG6DKrWj2hLJ7"
                                    thread_link="https://twitter.com/23dittrich/status/1822392491808534671"
                                    type="pro"
                                />
                            </div>
                            <div className="hidden md:flex">
                                <TestimonialCard
                                    title="Azores recs"
                                    list_username="23dittrich"
                                    thread_username="javimunoglez"
                                    list_link="https://maps.app.goo.gl/Ysninkt3FDTTNwVG6"
                                    thread_link="https://x.com/23dittrich/status/1822387532686049423"
                                    type="pro"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="mt-8 text-center md:mt-16">
                        <a href="/discover" title="" className="pb-2 text-base font-bold leading-7 text-gray-900 transition-all duration-200 border-b-2 border-gray-900 hover:border-gray-600 font-pj focus:outline-none focus:ring-1 focus:ring-gray-900 focus:ring-offset-2 hover:text-gray-600"> Discover more lists </a>
                    </div>
                </div>
            </div>
        </section>

    )
}
export default Testimonials;